import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy,CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {ReactiveFormsModule} from '@angular/forms'
import {HttpModule} from '@angular/http';
import {ImageuploadService} from './Imageupload.service'
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';
import {MatTooltipModule} from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';
import {ToastrModule, ToastrService} from 'ngx-toastr'
import {MatDialogModule} from '@angular/material/dialog'
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';


const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {

  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
  
  
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { SubcriptionComponent } from './views/subcription/subcription.component';
import { ProfileSetupComponent } from './views/profile-setup/profile-setup.component';
import { NgxStripeModule } from 'ngx-stripe';
import { LoginService } from './login-service';
import { SocialLogins } from './sociallogins';
import { ForgotComponent } from './views/forgot/forgot.component';
import { ResetComponent } from './views/reset/reset.component';
import { PasswordchangeComponent } from './views/passwordchange/passwordchange.component';
import { TermsConditionsComponent } from './views/terms-conditions/terms-conditions.component';
import { PrivacypolicyComponent } from './views/privacypolicy/privacypolicy.component';
// import { CollaboComponent } from './views/collabo/collabo.component';
import { InitiatorModule } from './views/initiator/initiator.module';
import { CollaboModule } from './views/collabo/collabo.module';
import { AdminForgotpasswordComponent } from './views/admin-forgotpassword/admin-forgotpassword.component';
import { AdminLoginComponent } from './views/admin-login/admin-login.component';
import { AdminModule } from './views/admin/admin.module';
import { HomepageComponent } from './views/homepage/homepage.component';
import { PostcollaboComponent } from './views/postcollabo/postcollabo.component';
import { DatePipe } from '@angular/common';
import {Collabo} from './views/postcollabo/collabo';
import { EmailverificationComponent } from './views/emailverification/emailverification.component';
import { BidacollaboComponent } from './views/bidacollabo/bidacollabo.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { RestrictKeywordDirective } from './restrict-keyword.directive';
// import { SubCompanyComponent } from './sub-company/sub-company.component';
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    ModalModule,
    NgbModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    IconModule,
    IconSetModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      closeButton: true
   }),
    HttpClientModule,HttpModule,
InitiatorModule,
CollaboModule,
AdminModule,
    MatSelectModule,
    MatDialogModule,
    NgSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCheckboxModule,
    CollapseModule.forRoot(),
    NgxStripeModule.forRoot('pk_test_51J8LqISITWWOerdHC12yr8TiDQzeiE7gJKKRaVmFnJ0ub9GtQHwvtl1CrWWM5fx4wc7bGsPFRRvt1Zr69WXBPswY00CUi4Mxzm')
     ],
  declarations: [
    RestrictKeywordDirective,
    AppComponent,
    ...APP_CONTAINERS,
    
    LoginComponent,
  RegisterComponent,
    SubcriptionComponent,
    ProfileSetupComponent,
    ForgotComponent,
    ResetComponent,
    PasswordchangeComponent,
    // CollaboComponent,
    TermsConditionsComponent,
    PrivacypolicyComponent,
    AdminForgotpasswordComponent,
    AdminLoginComponent,
    HomepageComponent,
    PostcollaboComponent,
    EmailverificationComponent,
    BidacollaboComponent,
    // SubCompanyComponent,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    IconSetService,LoginService,ImageuploadService,
    SocialLogins,ToastrService,DatePipe,Collabo,
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
